<template>
  <div>
    <!-- <b-row>
      <b-col>
        <b-alert v-if="externalLogInError" show variant="danger"><span v-html="externalLogInError"></span></b-alert>
        <div class="text-center">
          <span v-if="authPage == 'create'">
            Sign up with:            
          </span>
          <span v-if="authPage != 'create'">
            Log in with: 
          </span>
          <b-button>
            <g-signin-button :params="googleSignInParams" @success="onGoogleSignInSuccess" @error="onGoogleSignInError">
              <font-awesome-icon :icon="{ prefix: 'fab', iconName: 'google' }"/>
              Google
            </g-signin-button>
          </b-button>
          <b-button>
            <fb-signin-button :params="fbSignInParams" @success="onFacebookSignInSuccess" @error="onFacebookSignInError">
              <font-awesome-icon :icon="{ prefix: 'fab', iconName: 'facebook' }"/>
              Facebook
            </fb-signin-button>
          </b-button>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div class="strike">
           <span>or</span>
        </div>
      </b-col>
    </b-row> -->
    <b-row>
      <b-col md="3"></b-col>
      <b-col md="6" class="text-center">
        <div v-if="authPage == 'create'">
          <h2>{{signUpHeader}}</h2>
          <hr />
          <b-alert v-if="signUpError" show variant="danger"><span v-html="signUpError"></span></b-alert>
          <b-form @submit.prevent="onFormSignUp">
            <text-control form-name="signUp" label="First Name" v-model="signUpFirstName" required />
            <text-control form-name="signUp" label="Last Name" v-model="signUpLastName" required />
            <text-control form-name="signUp" label="Email Address" v-model="signUpEmail" type="email" required />
            <text-control form-name="signUp" label="New Password" v-model="signUpPassword" type="password" required description="We recommend a strong password that's at least 12 characters." />
            <text-control form-name="signUp" label="Confirm New Password" v-model="signUpConfirm" type="password" required :custom-validation="validateSignUpConfirm" />
            <b-button type="submit" variant="primary" class="mt-3">Sign Up</b-button>
          </b-form>
          <div class="mt-3">
            <a href="#" @click.prevent="authPage = 'login'">Already have an account? Log in.</a>
          </div>
          <div>
            <a href="#" @click.prevent="authPage = 'requestReset'">Forgot your password? Reset it.</a>
          </div>          
        </div>
        <div v-if="authPage == 'login'">
          <h2>{{logInHeader}}</h2>
          <hr />
          <b-alert v-if="logInError" show variant="danger"><span v-html="logInError"></span></b-alert>
          <b-form @submit.prevent="onFormLogIn">
            <div v-if="!logInUsesTFA">
              <text-control form-name="logIn" label="Email Address" v-model="logInEmail" type="email" required />
              <text-control form-name="logIn" label="Password" v-model="logInPassword" type="password" required />
              <b-button type="submit" variant="primary" class="mt-3">Log In</b-button>
            </div>
            <div v-if="logInUsesTFA">
              <p>This account uses two-factor authentication for added security. A verification code has been sent to you via SMS text message. Please enter the verification code below.</p>
              <text-control form-name="logIn" label="Verification Code" v-model="logInVerificationCode" required />
              <b-button type="submit" variant="primary" class="mt-3">Continue</b-button>
            </div>
          </b-form>
          <div class="mt-3">
            <a href="#" @click.prevent="authPage = 'create'">Don't have an account? Sign up.</a>
          </div>
          <div>
            <a href="#" @click.prevent="authPage = 'requestReset'">Forgot your password? Reset it.</a>
          </div>          
        </div>
        <div v-if="authPage == 'requestReset'">
          <h2>{{requestPasswordResetHeader}}</h2>
          <hr />
          <b-alert v-if="requestPasswordResetError" show variant="danger"><span v-html="requestPasswordResetError"></span></b-alert>
          <b-alert v-if="requestPasswordResetDone" show variant="success">An email has been sent to the address you provided with a link to reset your password.</b-alert>
          <b-form @submit.prevent="onFormRequestPasswordReset">
            <text-control form-name="requestReset" label="Email Address" v-model="requestPasswordResetEmail" type="email" required />
            <b-button type="submit" variant="primary" class="mt-3">Reset Password</b-button>
          </b-form>
          <div class="mt-3">
            <a href="#" @click.prevent="authPage = 'login'">Already have an account? Log in.</a>
          </div>
          <div>
            <a href="#" @click.prevent="authPage = 'create'">Don't have an account? Sign up.</a>
          </div>
        </div>
        <div v-if="authPage == 'reset'">
          <h2>{{resetPasswordHeader}}</h2>
          <hr />
          <b-alert v-if="resetPasswordError" show variant="danger"><span v-html="resetPasswordError"></span></b-alert>
          <b-form @submit.prevent="onFormResetPassword">
            <text-control form-name="resetPassword" label="Email Address" v-model="resetPasswordEmail" type="email" required />
            <text-control form-name="resetPassword" label="New Password" v-model="resetPasswordPassword" type="password" required description="We recommend a strong password that's at least 12 characters." />
            <text-control form-name="resetPassword" label="Confirm New Password" v-model="resetPasswordConfirm" type="password" required :custom-validation="validateResetPasswordConfirm" />
            <b-button type="submit" variant="primary" class="mt-3">Reset Password</b-button>
          </b-form>
          <div class="mt-3">
            <a href="#" @click.prevent="authPage = 'login'">Already have an account? Log in.</a>
          </div>
          <div>
            <a href="#" @click.prevent="authPage = 'create'">Don't have an account? Sign up.</a>
          </div>
        </div>
        <div v-if="authPage == 'change'">
          <h2>{{changePasswordHeader}}</h2>
          <hr />
          <b-alert v-if="changePasswordError" show variant="danger"><span v-html="changePasswordError"></span></b-alert>
          <b-form @submit.prevent="onChangePassword">
            <text-control label="Current Password" v-model="changePasswordOldPassword" type="password" required />
            <text-control label="New Password" v-model="changePasswordNewPassword" type="password" required description="We recommend a strong password that's at least 12 characters." />
            <text-control label="Confirm New Password" v-model="changePasswordConfirm" type="password" required :custom-validation="validateChangePasswordConfirm" />
            <b-button type="submit" variant="primary" class="mt-3">Change Password</b-button>
          </b-form>
        </div>
        <div v-if="authPage == 'verifyphonenumber'">
          <h2>{{verifyPhoneNumberHeader}}</h2>
          <p>Enabling two-factor authentication helps keep your account more secure. In order to log in, you'll need to provide both a password and a verification code that we'll send you via SMS text message.</p>
          <p>To enable two-factor authentication, please start by entering your cell phone number below. We'll send you a text message with unique code to verify your phone number. Once verified, we'll enable two-factor authentication.</p>
          <hr />
          <b-alert v-if="verifyPhoneNumberError" show variant="danger"><span v-html="verifyPhoneNumberError"></span></b-alert>
          <b-form @submit.prevent="onVerifyPhoneNumber">
            <text-control label="Phone Number" v-model="verifyPhoneNumberPhoneNumber" type="tel" required />
            <b-button type="submit" variant="primary" class="mt-3">Verify Phone Number</b-button>
          </b-form>
        </div>
        <div v-if="authPage == 'verifyverificationcode'">
          <h2>{{verifyVerificationCodeHeader}}</h2>
          <p>A verification code has been sent to {{verifyPhoneNumberPhoneNumber}}. Please enter the verification code below.</p>
          <hr />
          <b-alert v-if="verifyVerificationCodeVerificationCode" show variant="danger"><span v-html="verifyVerificationCodeError"></span></b-alert>
          <b-form @submit.prevent="onVerifyVerificationCode">
            <text-control label="Verification Code" v-model="verifyVerificationCodeVerificationCode" type="tel" required />
            <b-button type="submit" variant="primary" class="mt-3">Verify and Enable Two-Factor Authentication</b-button>
          </b-form>
        </div>
      </b-col>
      <b-col md="3"></b-col>
    </b-row>
  </div>
</template>

<script>
import axios from "axios";
import AuthMixin from '../Mixins/AuthMixin.vue';
import FormMixin from '../Mixins/FormMixin.vue';

export default {
  name: "AuthForm",
  mixins: [AuthMixin, FormMixin],
  props: {
    page: {
      default: 'create'
    },
    signUpHeader: {
      default: 'Sign Up'
    },
    logInHeader: {
      default: 'Log In'
    },
    requestPasswordResetHeader: {
      default: 'Request Password Reset'
    },
    resetPasswordHeader: {
      default: 'Reset Password'
    },
    changePasswordHeader: {
      default: 'Change Password'
    },
    verifyPhoneNumberHeader: {
      default: 'Enable Two Factor Authentication'
    },
    verifyVerificationCodeHeader: {
      default: 'Enable Two Factor Authentication'
    }
  },
  data() {
    return {
    }
  },
  computed: {
  },
  methods: {
    validateSignUpConfirm: function () {
      if (this.signUpPassword != this.signUpConfirm)
        return 'Passwords do not match';
      else
        return true;
    },
    validateResetPasswordConfirm: function () {
      if (this.resetPasswordPassword != this.resetPasswordConfirm)
        return 'Passwords do not match';
      else
        return true;
    },
    validateChangePasswordConfirm: function () {
      if (this.changePasswordNewPassword != this.changePasswordConfirm)
        return 'Passwords do not match';
      else
        return true;
    },
    onFormSignUp: function () {
      if (!this.isFormValid('signUp'))
        return;

      return this.onSignUp();
    },
    onFormLogIn: function () {
      if (!this.isFormValid('logIn'))
        return;

      return this.onLogIn();
    },
    onFormRequestPasswordReset: function () {
      if (!this.isFormValid('requestReset'))
        return;

      return this.onRequestPasswordReset();
    },
    onFormResetPassword: function () {
      if (!this.isFormValid('resetPassword'))
        return;

      return this.onResetPassword();
    }
  },
  watch: {
  },
  mounted () {
    if (this.$route.query.token) {
      this.resetPasswordToken = this.$route.query.token;
      this.authPage = 'reset';
    } else {
      this.authPage = this.page;
    }
  }
};
</script>